export const BIOMETRICS_BUTTON_DATA_TYPE = 'biometrics';
